// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ReadUnreadToggler-button-3IR_t {\n  padding: 0 6px;\n}\n.ReadUnreadToggler-button-3IR_t:hover .ReadUnreadToggler-default-2a-RE {\n  fill: #66b6ff;\n}\n.ReadUnreadToggler-default-2a-RE {\n  stroke: none;\n  fill: #a3a2a1;\n}\n.ReadUnreadToggler-unread-2fhsq {\n  fill: #0071d4;\n}\n", ""]);
// Exports
exports.locals = {
	"button": "ReadUnreadToggler-button-3IR_t",
	"default": "ReadUnreadToggler-default-2a-RE",
	"unread": "ReadUnreadToggler-unread-2fhsq"
};
module.exports = exports;
